export default "__VITE_ASSET__DcVtKGLM__"